import React from 'react'

function AboutSection() {
  return (
    <section className="ttm-row services-section clearfix">
    <div className="container">
      {/* row */}
      <div className="row">
        <div className="col-lg-5">
          <div className="margin_right30 res-991-margin_right0">
            <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-grey ttm-bg spacing-1">
              <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                <div className="ttm-col-wrapper-bg-layer-inner" />
              </div>
              <div className="layer-content">
                {/* section title */}
                <div className="section-title">
                  <div className="title-header">
                    <h2 className="title">NASK International – Your Premier Textile Buying House
                      Pakistan</h2>
                  </div>
                  <div className="title-desc">
                    <p>At NASK International, we are your trusted partner in the textile and
                      garment industry,
                      dedicated to serving clients worldwide. With a focus on
                      international markets,
                      particularly the USA and Europe, we specialize in sourcing, quality
                      control,
                      production management, and logistics services. Our commitment to
                      excellence
                      ensures exceptional quality and timely delivery, making us the
                      preferred choice
                      for businesses seeking reliable textile solutions.</p>
                  </div>
                </div>{/* section title end */}
                <div className="ttm_single_image-wrapper ttm_single_image_hover ml_70 mr_70">
                  <img className="img-fluid" src="images/single-img-01.jpg" alt="single-01" />
                  {/* <div class="ttm-play-icon-btn text-center">
                                        <div class="ttm-play-icon-animation ttm-play-icon-animation-skincolor">
                                            <a href="https://youtu.be/7e90gBu4pas" target="_self" class="ttm_prettyphoto">
                                                <div class="ttm-icon ttm-icon_element-fill ttm-icon_element-color-skincolor ttm-icon_element-size-sm ttm-icon_element-style-rounded">
                                                    <i class="fa fa-play ttm-textcolor-skincolor"></i>
                                                </div>
                                            </a>
                                        </div>
                                    </div> */}
                </div>
                {/* <p class="text-center padding_top30">The Largest Exporter of <a href="services1.html"><u class="ttm-textcolor-skincolor">Textile</u></a></p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="row ttm-vertical_sep">
            <div className="col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style1">
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-factory" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Sourcing Excellence and Production Management:</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Rely on NASK International extensive network of reputable suppliers
                      and manufacturers to procure the finest quality fabrics and
                      garments. Our experienced team meticulously oversees every step of
                      the production process, from material selection to finishing
                      touches, ensuring unparalleled results for our clients.</p>
                  </div>
                  {/* <a class="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-skincolor" href="about-us.html">read more</a> */}
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style1">
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-suit" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Stringent Quality Control Measures:</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Quality is our top priority at NASK International. Our rigorous
                      quality control procedures guarantee that all products meet
                      international standards and adhere to our clients’ specific
                      requirements. With regular inspections conducted by our dedicated
                      team of quality control inspectors, we minimize the risk of defects
                      or errors, ensuring the utmost satisfaction for our clients.</p>
                  </div>
                  {/* <a class="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-skincolor" href="fabric-printing.html">read more</a> */}
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
          <div className="ttm-horizontal_sep width-100 md-hide" />
          <div className="row ttm-vertical_sep">
            <div className="col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style1">
                <div className="featured-icon padding_top15">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-warehouse-1" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Comprehensive Logistics Solutions:</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Experience seamless logistics support with NASK International. Our
                      comprehensive services encompass shipping, customs clearance, and
                      meticulous documentation. Collaborating with trusted logistics
                      partners, we ensure the swift and secure delivery of your orders,
                      providing peace of mind throughout the process.</p>
                  </div>
                  {/* <a class="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-skincolor" href="fabric-printing.html">read more</a> */}
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style1">
                <div className="featured-icon padding_top15">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-fabric" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Explore Our Product Range:</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Find a diverse selection of high-quality textile solutions with NASK
                      International. From premium fabrics to expertly crafted garments, we
                      cater to the evolving needs of the fashion industry. Our products
                      are designed with precision, sustainability, and innovation in mind,
                      ensuring excellence in every piece.</p>
                  </div>
                  {/* <a class="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-skincolor" href="fabric-printing.html">read more</a> */}
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
        </div>
      </div>{/* row end */}
    </div>
  </section>
  
  )
}

export default AboutSection